import Svg, { Path } from "react-native-svg";
import { GetProps } from "tamagui";

const Apple = ({ color, ...props }: GetProps<typeof Svg>) => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <Path
      d="M9 1L9.15395 1.05128C10.8282 1.60891 11.9656 3.15939 11.9992 4.91668M11.9992 4.91668C11.9689 4.9166 11.9386 4.91168 11.9095 4.90193L10.1654 4.31757C9.28686 4.02322 8.35388 3.93036 7.43496 4.04582C3.70398 4.51458 1.24296 8.18582 2.21178 11.8375L2.49254 12.8958C3.51649 16.6696 5.83862 20.1724 9 22.4834C9.44631 22.8096 9.90656 23.1869 10.4859 22.8957L11.6031 22.3342C11.8858 22.1922 12.2191 22.1922 12.5017 22.3342L13.5903 22.8813C14.0392 23.1069 14.4583 22.9345 14.8164 22.6466C17.845 20.2113 20.0958 16.7977 21.4213 13.134L21.7882 11.8375C22.757 8.18582 20.296 4.51458 16.565 4.04582C15.6461 3.93036 14.7131 4.02322 13.8346 4.31757L12.0905 4.90193C12.0609 4.91185 12.03 4.91677 11.9992 4.91668ZM15 7C17.2091 7 19 8.79086 19 11"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </Svg>
);

export default Apple;
